import { gql } from '@apollo/client';

export const GET_PERMISSIONS = gql`
    query Permissions {
        permissions {
            name
        }
    }
`;
